import React from "react";
import Product from "./Product";

function ProductList({ items, ...props }) {
  return (
    <div className="list">
      {props.searching ? <><h2>Search Results</h2>
                          <p>showing {props.firstItemIndex+1} - {(props.pageNumber -1) * 30 +items.length} of {props.totalItems} results</p> 
                          <button className="back-button" onClick={props.resetList}>back to home</button></>:<h2>For You</h2>}
      
      {props.itemCount > 0 ? (
        items
          .filter((item) => !item.inBasket)
          .map((item) => (
            <Product
              key={item.trackId}
              item={item}
              {...props}
            />
          ))
      ) : (
        <div className="empty">No items found...</div>
      )}
    </div>
  );
}

export default ProductList;